import { render, staticRenderFns } from "./upload.component.vue?vue&type=template&id=8ed71da8&scoped=true"
import script from "./upload.component.vue?vue&type=script&lang=js"
export * from "./upload.component.vue?vue&type=script&lang=js"
import style0 from "./upload.component.vue?vue&type=style&index=0&id=8ed71da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed71da8",
  null
  
)

export default component.exports